import { getDateOrUndefined } from 'core/utils/dates';
import { RuleActionType } from 'modules/settings/pods/settings-automation-rules/constants/backend-enums';
import {
    Rule,
    RuleActionApi,
    RuleApi,
    RuleCreate,
    RuleCreateApi,
    RuleEdit,
    RuleEditApi,
} from 'modules/settings/pods/settings-automation-rules/types/automation-rules.type';

export const mapRuleFromApiToVm = (rule: RuleApi): Rule => ({
    id: rule.id,
    name: rule.name,
    trigger: rule.trigger,
    enabled: rule.enabled,
    lastExecutionTime: getDateOrUndefined(rule.lastExecutionTime),
    matches: rule.matches,
    conditions: rule.conditions,
    actions: rule.actions.map((action: RuleActionApi) => ({
        type: action.type,
        data: JSON.parse(action.data),
    })),
    version: rule.version,
});

export const mapRuleFromVmToCreateApi = (rule: RuleCreate): RuleCreateApi => ({
    name: rule.name,
    trigger: rule.trigger,
    conditions: rule.conditions,
    actions: rule.actions.map((action) => ({
        type: action.type as RuleActionType,
        data: JSON.stringify(action.data),
    })),
});

export const mapRuleFromVmToEditApi = (rule: RuleEdit): RuleEditApi => ({
    name: rule.name,
    trigger: rule.trigger,
    conditions: rule.conditions,
    enabled: rule.enabled,
    actions: rule.actions.map((action) => ({
        type: action.type as RuleActionType,
        data: JSON.stringify(action.data),
    })),
});
